import React from 'react';

import { IconProps } from '../types';

function VisaIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#CCD3D3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7502 15.8583H8.6905L7.14594 9.79247C7.07263 9.51344 6.91697 9.26676 6.688 9.1505C6.11658 8.85833 5.4869 8.6258 4.79999 8.50853V8.27499H8.11807C8.57601 8.27499 8.91947 8.6258 8.97671 9.03323L9.77811 13.4087L11.8368 8.27499H13.8393L10.7502 15.8583ZM14.9842 15.8583H13.039L14.6408 8.27499H16.586L14.9842 15.8583ZM19.1027 10.3758C19.1599 9.96738 19.5034 9.73384 19.9041 9.73384C20.5338 9.6752 21.2197 9.79248 21.7921 10.0836L22.1356 8.45091C21.5631 8.21737 20.9335 8.1001 20.362 8.1001C18.474 8.1001 17.1002 9.1505 17.1002 10.6083C17.1002 11.7174 18.0733 12.2997 18.7602 12.6505C19.5034 13.0003 19.7896 13.2338 19.7324 13.5836C19.7324 14.1083 19.1599 14.3419 18.5885 14.3419C17.9016 14.3419 17.2147 14.167 16.586 13.8748L16.2426 15.5086C16.9295 15.7997 17.6726 15.917 18.3595 15.917C20.4765 15.9746 21.7921 14.9252 21.7921 13.3501C21.7921 11.3666 19.1027 11.2503 19.1027 10.3758ZM28.6 15.8583L27.0554 8.27499H25.3964C25.0529 8.27499 24.7095 8.50853 24.595 8.85833L21.7349 15.8583H23.7374L24.137 14.7503H26.5975L26.8265 15.8583H28.6ZM25.6827 10.3174L26.2541 13.1754H24.6523L25.6827 10.3174Z"
        fill="#1434CB"
      />
    </svg>
  );
}

function MastercardIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#CCD3D3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 16.8292C15.9949 17.8273 14.459 18.4298 12.7807 18.4298C9.03582 18.4298 6 15.4301 6 11.7298C6 8.02948 9.03582 5.02979 12.7807 5.02979C14.459 5.02979 15.9949 5.63228 17.179 6.63033C18.363 5.63228 19.8989 5.02979 21.5773 5.02979C25.3221 5.02979 28.358 8.02948 28.358 11.7298C28.358 15.4301 25.3221 18.4298 21.5773 18.4298C19.8989 18.4298 18.363 17.8273 17.179 16.8292Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 16.8292C18.6369 15.6003 19.5614 13.7717 19.5614 11.7298C19.5614 9.68783 18.6369 7.85923 17.179 6.63032C18.363 5.63228 19.8989 5.02979 21.5773 5.02979C25.3221 5.02979 28.3579 8.02948 28.3579 11.7298C28.3579 15.4301 25.3221 18.4298 21.5773 18.4298C19.8989 18.4298 18.363 17.8273 17.179 16.8292Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 16.8292C18.6369 15.6003 19.5614 13.7717 19.5614 11.7298C19.5614 9.68787 18.6369 7.85927 17.179 6.63037C15.7211 7.85927 14.7966 9.68787 14.7966 11.7298C14.7966 13.7717 15.7211 15.6003 17.179 16.8292Z"
        fill="#FF5E00"
      />
    </svg>
  );
}

function AmexIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="34" height="24" rx="4" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.0954 8.5L2.91429 15.7467H6.72253L7.19464 14.5913H8.27378L8.74589 15.7467H12.9377V14.8649L13.3112 15.7467H15.4795L15.853 14.8462V15.7467H24.5708L25.6309 14.6213L26.6235 15.7467L31.1011 15.7561L27.91 12.1436L31.1011 8.5H26.6929L25.661 9.60463L24.6997 8.5H15.2159L14.4015 10.3704L13.568 8.5H9.76772V9.35186L9.34497 8.5H6.0954ZM6.83224 9.52881H8.68855L10.7986 14.4429V9.52881H12.8321L14.4619 13.0522L15.9639 9.52881H17.9872V14.7288H16.756L16.746 10.6541L14.9511 14.7288H13.8497L12.0448 10.6541V14.7288H9.51199L9.03182 13.563H6.43764L5.95847 14.7278H4.60143L6.83224 9.52881ZM24.1198 9.52881H19.1136V14.7258H24.0423L25.6309 13.0034L27.162 14.7258H28.7626L26.4362 12.1423L28.7626 9.52881H27.2315L25.651 11.2314L24.1198 9.52881ZM7.73528 10.4087L6.8806 12.4854H8.58896L7.73528 10.4087ZM20.35 11.5551V10.6059V10.605H23.4737L24.8367 12.1231L23.4133 13.6495H20.35V12.6132H23.081V11.5551H20.35Z"
        fill="white"
      />
    </svg>
  );
}

function DiscoverIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#CCD3D3"
      />
      <path
        d="M14 23L33 17.25V20C33 21.6569 31.6569 23 30 23H14Z"
        fill="#FD6020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3937 9.11084C30.439 9.11084 31.0139 9.59438 31.0139 10.5077C31.0662 11.2062 30.5958 11.7972 29.9686 11.9046L31.3797 13.8925H30.2822L29.0801 11.9584H28.9756V13.8925H28.0871V9.11084H29.3937ZM28.9756 11.3139H29.2369C29.8118 11.3139 30.0732 11.0453 30.0732 10.5617C30.0732 10.1319 29.8118 9.86328 29.2369 9.86328H28.9756V11.3139ZM25.0034 13.8925H27.5122V13.0866H25.8919V11.7972H27.4599V10.9913H25.8919V9.91674H27.5122V9.11084H25.0034V13.8925ZM22.3902 12.3345L21.1881 9.11084H20.2474L22.1812 14H22.6515L24.5853 9.11084H23.6446L22.3902 12.3345ZM11.7805 11.5283C11.7805 12.8715 12.8258 13.9998 14.1324 13.9998C14.5505 13.9998 14.9164 13.8923 15.2823 13.7311V12.6566C15.0209 12.9789 14.6551 13.1939 14.237 13.1939C13.4007 13.1939 12.7213 12.5491 12.7213 11.6895V11.582C12.669 10.7224 13.3485 9.97024 14.1847 9.91651C14.6028 9.91651 15.0209 10.1314 15.2823 10.4538V9.37924C14.9687 9.16433 14.5505 9.11061 14.1847 9.11061C12.8258 9.00315 11.7805 10.1314 11.7805 11.5283ZM10.1603 10.9376C9.63762 10.7227 9.48082 10.6152 9.48082 10.3466C9.53309 10.0242 9.79441 9.75557 10.108 9.8093C10.3693 9.8093 10.6306 9.97048 10.8397 10.1854L11.3101 9.54066C10.9442 9.2183 10.4739 9.00339 10.0035 9.00339C9.27176 8.94967 8.64459 9.54066 8.59232 10.2928V10.3466C8.59232 10.9913 8.85365 11.3674 9.68988 11.636C9.89894 11.6897 10.108 11.7972 10.3171 11.9046C10.4739 12.0121 10.5784 12.1733 10.5784 12.3882C10.5784 12.7643 10.2648 13.0866 9.95121 13.0866H9.89894C9.48082 13.0866 9.11497 12.818 8.95818 12.4419L8.38326 13.0329C8.69685 13.6239 9.32403 13.9463 9.95121 13.9463C10.7874 14 11.4669 13.3553 11.5191 12.4956V12.3345C11.4669 11.6897 11.2056 11.3674 10.1603 10.9376ZM7.12892 13.8925H8.01742V9.11084H7.12892V13.8925ZM3 9.11086H4.30662H4.56794C5.8223 9.16458 6.81532 10.2391 6.76306 11.5286C6.76306 12.227 6.44947 12.8717 5.92682 13.3553C5.45644 13.7314 4.88153 13.9463 4.30662 13.8926H3V9.11086ZM4.14987 13.0865C4.56799 13.1402 5.03837 12.979 5.35196 12.7104C5.66555 12.388 5.82234 11.9582 5.82234 11.4746C5.82234 11.0448 5.66555 10.615 5.35196 10.2926C5.03837 10.024 4.56799 9.86283 4.14987 9.91656H3.88855V13.0865H4.14987Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9477 9C16.6411 9 15.5435 10.0745 15.5435 11.4714C15.5435 12.8146 16.5888 13.9429 17.9477 13.9966C19.3066 14.0503 20.3519 12.9221 20.4042 11.5252C20.3519 10.1283 19.3066 9 17.9477 9V9Z"
        fill="#FD6020"
      />
    </svg>
  );
}

function ApplePayIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D1D9E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44921 8.34316C9.16382 8.69506 8.70721 8.97261 8.2506 8.93296C8.19353 8.45715 8.41707 7.95161 8.67867 7.63936C8.96406 7.27755 9.46348 7.01983 9.86777 7C9.91533 7.49563 9.72983 7.98135 9.44921 8.34316ZM9.86297 9.02712C9.46071 9.003 9.09366 9.15319 8.79718 9.2745C8.60639 9.35256 8.44483 9.41867 8.32191 9.41867C8.18397 9.41867 8.01574 9.34903 7.82685 9.27084L7.82685 9.27084C7.57935 9.16838 7.29638 9.05124 6.99964 9.05686C6.31948 9.06677 5.68688 9.46823 5.33967 10.1076C4.62621 11.3863 5.15417 13.2796 5.84384 14.3205C6.18155 14.8359 6.58584 15.4009 7.11855 15.3811C7.35291 15.3719 7.5215 15.2973 7.69597 15.2202C7.89683 15.1314 8.10549 15.0391 8.43131 15.0391C8.74582 15.0391 8.94536 15.129 9.1369 15.2152C9.31903 15.2973 9.49393 15.376 9.75358 15.3712C10.3053 15.3613 10.6525 14.8557 10.9902 14.3403C11.3547 13.7871 11.5148 13.2471 11.5391 13.1652L11.542 13.1557C11.5414 13.1551 11.5369 13.153 11.5289 13.1492C11.4071 13.0911 10.476 12.6469 10.467 11.4557C10.4581 10.4559 11.2056 9.94935 11.3233 9.86961L11.3233 9.8696C11.3304 9.86476 11.3353 9.86149 11.3374 9.85978C10.8618 9.12625 10.1198 9.04695 9.86297 9.02712ZM13.6824 15.3167V7.5898H16.4649C17.9013 7.5898 18.9049 8.62071 18.9049 10.1274C18.9049 11.6341 17.8822 12.675 16.4268 12.675H14.8334V15.3167H13.6824ZM14.8333 8.60088H16.1603C17.1592 8.60088 17.7299 9.15599 17.7299 10.1324C17.7299 11.1088 17.1592 11.6688 16.1556 11.6688H14.8333V8.60088ZM22.7053 14.3898C22.4009 14.9945 21.7302 15.3761 21.0072 15.3761C19.9371 15.3761 19.1903 14.712 19.1903 13.7108C19.1903 12.7196 19.9133 12.1496 21.2498 12.0653L22.6862 11.9761V11.5499C22.6862 10.9204 22.2915 10.5784 21.5875 10.5784C21.0072 10.5784 20.5839 10.8907 20.4983 11.3665H19.4614C19.4947 10.3653 20.3984 9.63675 21.6208 9.63675C22.9383 9.63675 23.7945 10.3554 23.7945 11.4706V15.3167H22.729V14.3898H22.7053ZM21.3163 14.4592C20.7027 14.4592 20.3127 14.1519 20.3127 13.6811C20.3127 13.1954 20.6885 12.9129 21.4067 12.8683L22.6861 12.784V13.2202C22.6861 13.9438 22.0964 14.4592 21.3163 14.4592ZM27.3284 15.619C26.867 16.9721 26.3391 17.4181 25.2166 17.4181C25.131 17.4181 24.8456 17.4082 24.779 17.3884V16.4616C24.8503 16.4715 25.0263 16.4814 25.1167 16.4814C25.6256 16.4814 25.911 16.2584 26.087 15.6785L26.1916 15.3365L24.2415 9.7111H25.4449L26.8004 14.2759H26.8242L28.1798 9.7111H29.3499L27.3284 15.619Z"
        fill="black"
      />
    </svg>
  );
}

function PaypalIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D1D9E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6142 18.4483L14.8349 16.9992L14.3432 16.9873H11.9953L13.627 6.2937C13.6321 6.26132 13.6485 6.23126 13.6725 6.20987C13.6967 6.18849 13.7274 6.17676 13.7596 6.17676H17.7185C19.033 6.17676 19.94 6.45939 20.4135 7.01734C20.6355 7.27908 20.7769 7.55267 20.8453 7.85364C20.9171 8.16951 20.9183 8.54685 20.8483 9.00715L20.8432 9.04063V9.33561L21.0652 9.46563C21.2521 9.56815 21.4008 9.68546 21.5147 9.81975C21.7046 10.0436 21.8274 10.3281 21.8793 10.6652C21.933 11.012 21.9153 11.4248 21.8274 11.892C21.7261 12.4295 21.5624 12.8976 21.3412 13.2805C21.1378 13.6334 20.8787 13.9262 20.5709 14.153C20.2771 14.3686 19.9281 14.5322 19.5335 14.6369C19.1511 14.7398 18.715 14.7917 18.2368 14.7917H17.9287C17.7085 14.7917 17.4945 14.8737 17.3265 15.0207C17.158 15.1708 17.0467 15.3758 17.0125 15.6L16.9892 15.7305L16.5992 18.2848L16.5816 18.3785C16.5768 18.4082 16.5688 18.423 16.557 18.433C16.5465 18.4422 16.5313 18.4483 16.5165 18.4483H14.6142Z"
        fill="#28356A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2757 9.07471C21.2639 9.15279 21.2504 9.23258 21.2352 9.31458C20.7131 12.0852 18.9269 13.0424 16.6456 13.0424H15.4841C15.2051 13.0424 14.9699 13.2517 14.9265 13.5362L14.1634 18.5394C14.1351 18.7263 14.2744 18.8945 14.4567 18.8945H16.5169C16.7608 18.8945 16.968 18.7113 17.0064 18.4627L17.0267 18.3545L17.4146 15.8103L17.4395 15.6708C17.4775 15.4213 17.6852 15.238 17.9291 15.238H18.2372C20.2331 15.238 21.7957 14.4004 22.2524 11.9766C22.4431 10.9641 22.3444 10.1186 21.8396 9.52402C21.6868 9.34476 21.4973 9.19592 21.2757 9.07471Z"
        fill="#298FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7293 8.84944C20.6495 8.82537 20.5672 8.80362 20.4828 8.78394C20.3979 8.76476 20.311 8.74777 20.2215 8.73287C19.9083 8.68057 19.5651 8.65576 19.1975 8.65576H16.0945C16.018 8.65576 15.9454 8.6736 15.8805 8.70586C15.7373 8.77698 15.6311 8.91701 15.6053 9.08845L14.9451 13.41L14.9262 13.536C14.9696 13.2515 15.2047 13.0422 15.4838 13.0422H16.6453C18.9266 13.0422 20.7128 12.0845 21.2349 9.31439C21.2505 9.2324 21.2636 9.15261 21.2753 9.07452C21.1433 9.00206 21.0002 8.94011 20.8462 8.88732C20.8081 8.87425 20.7689 8.86166 20.7293 8.84944Z"
        fill="#22284F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6055 9.08862C15.6312 8.91718 15.7375 8.77715 15.8807 8.70652C15.9461 8.67414 16.0182 8.6563 16.0947 8.6563H19.1977C19.5653 8.6563 19.9085 8.68123 20.2217 8.73353C20.3111 8.74831 20.398 8.76542 20.4829 8.7846C20.5673 8.80415 20.6496 8.82603 20.7294 8.84998C20.769 8.8622 20.8083 8.8749 20.8467 8.88749C21.0008 8.94028 21.1439 9.00272 21.276 9.07469C21.4313 8.05082 21.2747 7.3537 20.7391 6.72245C20.1486 6.0274 19.0829 5.72998 17.7192 5.72998H13.7601C13.4816 5.72998 13.2439 5.9393 13.2009 6.22426L11.5519 17.0279C11.5194 17.2416 11.6789 17.4344 11.8874 17.4344H14.3316L15.6055 9.08862Z"
        fill="#28356A"
      />
    </svg>
  );
}

function SepaIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D1D9E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3418 12.488H20.4549C20.8079 12.4749 21.0226 12.4469 21.0998 12.4031C21.2054 12.3432 21.2762 12.2235 21.3114 12.0438C21.334 11.9242 21.3452 11.7464 21.3452 11.5102C21.3452 11.2209 21.3229 11.0064 21.2779 10.8663C21.2136 10.6701 21.0598 10.5506 20.8162 10.5072C20.768 10.5006 20.6527 10.4971 20.47 10.4971H19.3418V12.488ZM17.5561 15.8414V9H20.8828C21.3391 9 21.6873 9.03843 21.9266 9.1152C22.4737 9.29199 22.8408 9.65395 23.0289 10.201C23.1259 10.4881 23.1745 10.9203 23.1745 11.4975C23.1745 12.1915 23.1206 12.6902 23.0141 12.9938C22.8008 13.5942 22.3615 13.9401 21.6983 14.0297C21.6203 14.0432 21.2884 14.0552 20.7027 14.0648L20.4063 14.075H19.3417V15.8414H17.5561ZM10.2511 11.1824H8.58996C8.58996 10.9012 8.55793 10.7126 8.49418 10.6166C8.39534 10.4745 8.12248 10.4033 7.67592 10.4033C7.24223 10.4033 6.95472 10.4443 6.81443 10.5262C6.67421 10.6083 6.60403 10.787 6.60403 11.0622C6.60403 11.3113 6.66617 11.4753 6.79076 11.5539C6.88003 11.6096 6.99795 11.6424 7.145 11.6522L7.48 11.6766C8.19797 11.7258 8.64639 11.7604 8.82524 11.78C9.39301 11.839 9.80464 11.9948 10.06 12.2471C10.261 12.4439 10.3809 12.7012 10.4191 13.019C10.4415 13.209 10.4526 13.4241 10.4526 13.663C10.4526 14.2138 10.4016 14.6172 10.2996 14.8728C10.1146 15.3418 9.69912 15.6381 9.05262 15.7625C8.78177 15.8151 8.36741 15.8414 7.81009 15.8414C6.87979 15.8414 6.23144 15.7843 5.86537 15.6695C5.41607 15.5289 5.11987 15.2441 4.97651 14.8151C4.89667 14.5763 4.85715 14.1787 4.85715 13.622H6.5183L6.51847 13.7643C6.51847 14.0613 6.60129 14.2524 6.76654 14.3375C6.88107 14.3961 7.01936 14.4269 7.18195 14.4306H7.79263C8.10428 14.4306 8.30318 14.4142 8.38898 14.3811C8.54167 14.3192 8.64188 14.2195 8.68977 14.0816C8.71521 13.9967 8.72784 13.8868 8.72784 13.7523C8.72784 13.4511 8.62119 13.2679 8.4083 13.2021C8.32869 13.1762 7.95827 13.14 7.29713 13.0941C6.76621 13.055 6.39741 13.0174 6.19087 12.9809C5.647 12.876 5.28455 12.6603 5.10369 12.3328C4.94472 12.0545 4.8652 11.6335 4.8652 11.0702C4.8652 10.6413 4.90818 10.2973 4.99406 10.0386C5.08002 9.77985 5.21855 9.5834 5.40971 9.44902C5.68974 9.24277 6.04808 9.12167 6.48426 9.08549C6.84719 9.05287 7.2498 9.03619 7.69266 9.03619C8.38986 9.03619 8.88673 9.07752 9.18293 9.15944C9.90582 9.35971 10.2672 9.9207 10.2672 10.8426C10.2672 10.9182 10.2618 11.0312 10.2511 11.1824ZM25.7947 10.3606L26.6313 13.3262H24.9828L25.7947 10.3606ZM24.5986 14.659H26.986L27.3266 15.8414H29.1353L27.1174 9H24.4238L22.4304 15.8414H24.2778L24.5986 14.659Z"
        fill="#10298E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0916 9.96265C15.828 9.96265 16.4853 10.3125 16.9174 10.8604L17.3023 10.0095C16.7003 9.42274 15.881 9.06104 14.9773 9.06104C13.5704 9.06104 12.3668 9.93725 11.8728 11.1776H11.1223L10.6791 12.1573H11.6446C11.6374 12.2482 11.6327 12.3391 11.6327 12.4319C11.6327 12.5442 11.6384 12.6552 11.6492 12.7648H11.1639L10.7208 13.7449H11.8959C12.4039 14.9538 13.5924 15.8026 14.9773 15.8026C15.6753 15.8026 16.3229 15.587 16.8591 15.2186V14.0175C16.4273 14.5245 15.7957 14.8449 15.0916 14.8449C14.2685 14.8449 13.5445 14.4072 13.1228 13.7449H15.5835L16.0266 12.7648H12.7608C12.744 12.6469 12.735 12.5264 12.735 12.4036C12.735 12.3206 12.7392 12.2385 12.7469 12.1573H16.3012L16.7443 11.1776H13.0543C13.4624 10.4513 14.2218 9.96265 15.0916 9.96265Z"
        fill="#FFBE00"
      />
    </svg>
  );
}

function IdealIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D1D9E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3417 5H9V19.0221H18.3417V19.0194C20.3823 18.9919 21.9989 18.4902 23.146 17.5242C24.5412 16.3494 25.2486 14.4945 25.2486 12.011C25.2486 10.8239 25.0625 9.75911 24.6956 8.8462C24.3445 7.97287 23.8257 7.23033 23.1537 6.63917C21.97 5.59803 20.3085 5.03507 18.3417 5.00309V5Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.165 5.93115C19.9755 5.93115 21.4844 6.41665 22.5286 7.33518C23.7091 8.3735 24.3076 9.94663 24.3076 12.0109C24.3076 16.1019 22.2983 18.0907 18.165 18.0907H9.94091V5.93115H18.165Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.908 17.1765H14.6053V7.06494H17.908H17.7747C20.529 7.06494 23.4608 8.14081 23.4608 12.134C23.4608 16.3555 20.529 17.1765 17.7747 17.1765H17.908Z"
        fill="#CD0067"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8061 17.1717H13.4099V12.8926H10.8061V17.1717Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6064 10.7532C13.6064 11.5588 12.9465 12.2123 12.1326 12.2123C11.3187 12.2123 10.6587 11.5588 10.6587 10.7532C10.6587 9.94762 11.3187 9.29443 12.1326 9.29443C12.9465 9.29443 13.6064 9.94762 13.6064 10.7532Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5317 10.0877V11.6959H14.9031C15.042 11.6959 15.1422 11.6882 15.2038 11.6727C15.2845 11.6528 15.3514 11.6192 15.4046 11.5717C15.4578 11.5242 15.5013 11.4461 15.5349 11.3373C15.5685 11.2286 15.5853 11.0804 15.5853 10.8926C15.5853 10.7049 15.5685 10.5609 15.5349 10.4604C15.5013 10.3599 15.4542 10.2815 15.3937 10.2252C15.3332 10.1689 15.2565 10.1308 15.1635 10.1109C15.094 10.0955 14.958 10.0877 14.7552 10.0877H14.5317ZM14.0361 9.67529H14.9428C15.1473 9.67529 15.3032 9.69078 15.4105 9.72175C15.5546 9.76379 15.6781 9.83851 15.7809 9.94582C15.8837 10.0531 15.9619 10.1846 16.0156 10.34C16.0692 10.4954 16.096 10.6871 16.096 10.915C16.096 11.1153 16.0709 11.2879 16.0206 11.4328C15.9592 11.6099 15.8714 11.7532 15.7575 11.8627C15.6714 11.9457 15.5552 12.0104 15.4088 12.0569C15.2993 12.0912 15.1529 12.1083 14.9697 12.1083H14.0361V9.67529Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9428 9.74193C15.14 9.74193 15.291 9.75667 15.3917 9.78573C15.5234 9.82415 15.638 9.89349 15.7322 9.9917C15.8278 10.0915 15.9017 10.216 15.952 10.3616C16.003 10.5094 16.0288 10.6956 16.0288 10.9152C16.0288 11.1071 16.0047 11.274 15.957 11.4114C15.8993 11.5776 15.8164 11.7134 15.7106 11.8151C15.6324 11.8905 15.524 11.9506 15.3883 11.9937C15.2861 12.0256 15.1452 12.0419 14.9697 12.0419H14.1033V9.74193H14.9428ZM13.9689 9.60889V12.175H14.9697C15.1589 12.175 15.3135 12.1566 15.4291 12.1204C15.585 12.0709 15.7112 12.0003 15.8044 11.9105C15.9254 11.7941 16.0195 11.6407 16.0842 11.4546C16.1367 11.3033 16.1632 11.1218 16.1632 10.9152C16.1632 10.681 16.135 10.4803 16.0792 10.3186C16.0226 10.1547 15.9387 10.0139 15.8297 9.90017C15.7191 9.78472 15.5845 9.70324 15.4295 9.65806C15.3148 9.62496 15.1557 9.60889 14.9428 9.60889H13.9689Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7552 10.1545C15.0003 10.1545 15.1045 10.1663 15.1488 10.1761C15.2297 10.1934 15.2965 10.2263 15.3476 10.2739C15.3996 10.3223 15.4411 10.3922 15.471 10.4815C15.5022 10.5748 15.518 10.7132 15.518 10.8929C15.518 11.0731 15.502 11.2162 15.4705 11.3181C15.4407 11.4147 15.4034 11.4835 15.3596 11.5226C15.3149 11.5624 15.257 11.5913 15.1876 11.6084C15.1314 11.6225 15.0357 11.6297 14.903 11.6297H14.5989V10.1545H14.7552ZM14.4645 10.0215V11.7627H14.903C15.0489 11.7627 15.1527 11.7544 15.2203 11.7375C15.3111 11.7151 15.3883 11.676 15.4496 11.6214C15.5126 11.5651 15.5615 11.4787 15.5991 11.3571C15.635 11.2409 15.6524 11.0891 15.6524 10.8929C15.6524 10.6963 15.6348 10.548 15.5986 10.4397C15.5616 10.3291 15.5081 10.2407 15.4397 10.177C15.3705 10.1126 15.2823 10.0686 15.1777 10.0462C15.1031 10.0296 14.9647 10.0215 14.7552 10.0215H14.4645Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6569 12.1083V9.67529H18.4765V10.0877H17.1525V10.6266H18.3841V11.039H17.1525V11.6959H18.5236V12.1083H16.6569Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4094 9.74193V10.0213H17.0853V10.6932H18.317V10.9726H17.0853V11.7625H18.4564V12.0419H16.7241V9.74193H18.4094ZM16.5897 9.60889V12.175H18.5908V11.6295H17.2198V11.1056H18.4514V10.5601H17.2198V10.1544H18.5438V9.60889H16.5897Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3857 11.1438L20.0469 10.2424L19.7148 11.1438H20.3857ZM21.2995 12.1083H20.7595L20.545 11.5562H19.5629L19.3595 12.1083H18.8329L19.7881 9.67529H20.3164L21.2995 12.1083Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2709 9.74193C20.3023 9.81963 21.1331 11.8759 21.2002 12.0419H20.8056C20.7774 11.9693 20.5911 11.4898 20.5911 11.4898H19.5159C19.5159 11.4898 19.3397 11.9678 19.3124 12.0419H18.931C18.9958 11.877 19.8031 9.82074 19.8341 9.74193H20.2709ZM19.7421 9.60889L18.7346 12.175H19.4065C19.4065 12.175 19.5826 11.697 19.6099 11.6228H20.4988C20.527 11.6955 20.7133 12.175 20.7133 12.175H21.3987L20.3619 9.60889H19.7421Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0475 10.4347C20.1211 10.6307 20.2457 10.9619 20.289 11.0771H19.8108C19.8531 10.9624 19.9752 10.631 20.0475 10.4347ZM19.6188 11.2102H20.4824L20.0462 10.0498L19.6188 11.2102Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7141 12.1084V9.69531H22.2098V11.696H23.4448V12.1084H21.7141Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1426 9.76195V11.7626H23.3776V12.042H21.7813V9.76195H22.1426ZM21.6469 9.62891V12.175H23.512V11.6296H22.277V9.62891H21.6469Z"
        fill="white"
      />
    </svg>
  );
}

function AfterpayIcon({ size = '1em', ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 73 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M71.8896 2.82538L67.4609 0.295879C65.9867 -0.547287 64.1441 0.511424 64.1441 2.21044V2.49572C64.1441 2.65421 64.2267 2.80002 64.3664 2.87609L65.4022 3.46568C65.6881 3.63051 66.0439 3.4213 66.0439 3.09164V2.4133C66.0439 2.07731 66.4061 1.8681 66.6984 2.03293L68.7317 3.19941L70.7586 4.35956C71.0509 4.52439 71.0509 4.94914 70.7586 5.11397L68.7317 6.27412L66.6984 7.4406C66.4061 7.60543 66.0439 7.39622 66.0439 7.06023V6.72423C66.0439 5.02522 64.2012 3.96016 62.7271 4.80967L58.2983 7.33917C56.8179 8.18868 56.8179 10.3251 58.2983 11.1746L62.7271 13.7041C64.2012 14.5473 66.0439 13.4886 66.0439 11.7896V11.5043C66.0439 11.3458 65.9613 11.2 65.8215 11.1239L64.7858 10.5343C64.4999 10.3695 64.1441 10.5787 64.1441 10.9084V11.5867C64.1441 11.9227 63.7819 12.1319 63.4896 11.9671L61.4563 10.8006L59.4294 9.64044C59.1371 9.47561 59.1371 9.05086 59.4294 8.88603L61.4563 7.72588L63.4896 6.5594C63.7819 6.39457 64.1441 6.60378 64.1441 6.93977V7.27577C64.1441 8.97479 65.9867 10.0398 67.4609 9.19033L71.8896 6.66083C73.3701 5.80499 73.3701 3.67488 71.8896 2.82538Z"
        fill="black"
      />
      <path
        d="M57.4652 3.24378L52.3185 13.8499H50.1835L52.1088 9.88768L49.0779 3.24378H51.27L53.2144 7.69418L55.3366 3.24378H57.4652Z"
        fill="black"
      />
      <path
        d="M6.00457 7.00952C6.00457 5.7416 5.08323 4.85406 3.95221 4.85406C2.82119 4.85406 1.89986 5.76062 1.89986 7.00952C1.89986 8.24574 2.82119 9.16499 3.95221 9.16499C5.08323 9.16499 6.00457 8.27744 6.00457 7.00952ZM6.02363 10.7752V9.79895C5.46447 10.4773 4.63209 10.8957 3.64086 10.8957C1.56945 10.8957 0 9.24106 0 7.00952C0 4.797 1.63299 3.11067 3.68534 3.11067C4.65116 3.11067 5.46447 3.53543 6.02363 4.19474V3.2438H7.87901V10.7752H6.02363Z"
        fill="black"
      />
      <path
        d="M16.9021 9.10157C16.254 9.10157 16.0697 8.86067 16.0697 8.22671V4.88574H17.2643V3.24378H16.0697V1.4053H14.1698V3.24378H11.7172V2.49571C11.7172 1.86175 11.9586 1.62085 12.6258 1.62085H13.0452V0.16274H12.1302C10.5607 0.16274 9.81732 0.676247 9.81732 2.24213V3.25012H8.76255V4.88574H9.81732V10.7752H11.7172V4.88574H14.1698V8.57538C14.1698 10.1096 14.7608 10.7752 16.2984 10.7752H17.277V9.10157H16.9021Z"
        fill="black"
      />
      <path
        d="M23.7267 6.33115C23.5933 5.35485 22.7927 4.76527 21.8523 4.76527C20.9183 4.76527 20.1431 5.33583 19.9524 6.33115H23.7267ZM19.9334 7.50398C20.0668 8.61974 20.8674 9.2537 21.8841 9.2537C22.6847 9.2537 23.301 8.87967 23.6632 8.27741H25.6139C25.1628 9.87499 23.7267 10.8957 21.8396 10.8957C19.5585 10.8957 17.9573 9.29808 17.9573 7.02217C17.9573 4.74625 19.6475 3.1043 21.8841 3.1043C24.1334 3.1043 25.7664 4.75893 25.7664 7.02217C25.7664 7.187 25.7537 7.35183 25.7219 7.50398H19.9334Z"
        fill="black"
      />
      <path
        d="M37.864 7.00949C37.864 5.79228 36.9426 4.85403 35.8116 4.85403C34.6806 4.85403 33.7593 5.76059 33.7593 7.00949C33.7593 8.24571 34.6806 9.16495 35.8116 9.16495C36.9426 9.16495 37.864 8.23303 37.864 7.00949ZM31.8848 13.8499V3.24377H33.7402V4.22007C34.2994 3.52905 35.1317 3.1043 36.123 3.1043C38.1626 3.1043 39.7638 4.77795 39.7638 6.99047C39.7638 9.20299 38.1308 10.8893 36.0785 10.8893C35.1254 10.8893 34.3438 10.5153 33.7974 9.88132V13.8436H31.8848V13.8499Z"
        fill="black"
      />
      <path
        d="M46.4538 7.00952C46.4538 5.7416 45.5324 4.85406 44.4014 4.85406C43.2704 4.85406 42.3491 5.76062 42.3491 7.00952C42.3491 8.24574 43.2704 9.16499 44.4014 9.16499C45.5324 9.16499 46.4538 8.27744 46.4538 7.00952ZM46.4728 10.7752V9.79895C45.9137 10.4773 45.0813 10.8957 44.0901 10.8957C42.0187 10.8957 40.4492 9.24106 40.4492 7.00952C40.4492 4.797 42.0822 3.11067 44.1345 3.11067C45.1004 3.11067 45.9137 3.53543 46.4728 4.19474V3.2438H48.3282V10.7752H46.4728Z"
        fill="black"
      />
      <path
        d="M28.5352 3.97916C28.5352 3.97916 29.0054 3.1043 30.1682 3.1043C30.6638 3.1043 30.9815 3.27547 30.9815 3.27547V5.19636C30.9815 5.19636 30.2825 4.76527 29.6408 4.85403C28.999 4.94278 28.5924 5.52602 28.5924 6.31213V10.7689H26.6735V3.24377H28.5288V3.97916H28.5352Z"
        fill="black"
      />
    </svg>
  );
}

export const PAYMENT_TYPES = {
  AFTERPAY: 'afterpay',
  APPLPAY: 'applepay',
  AP_AMEX: `ap_amex`,
  AP_DISCOVER: `ap_discover`,
  AP_MASTERCARD: `ap_mastercard`,
  AP_VISA: 'ap_visa',
  AMEX: 'amex',
  CASHAPP_PAY: 'cashapppay',
  CLEARPAY_PAY: 'clearpay',
  DISCOVER: 'discover',
  IDEAL: 'ideal',
  MC: 'mc',
  MASTERCARD: 'mastercard',
  PAYPAL_LITLE: `paypallitle`,
  PAYPAL: `paypal`,
  PAYPAL_BRAINTREE: `braintreepaypal`,
  SEPA: 'sepadirectdebit',
  VI: 'vi',
  VISA: 'visa',
};

interface PaymentTypeIconProps extends IconProps {
  paymentType: string;
}

const PaymentTypeIcon = ({
  paymentType,
  size,
  ...rest
}: PaymentTypeIconProps) => {
  switch (paymentType) {
    case PAYMENT_TYPES.AFTERPAY:
      return <AfterpayIcon size={size} {...rest} />;
    case PAYMENT_TYPES.AMEX:
      return <AmexIcon size={size} {...rest} />;
    case PAYMENT_TYPES.APPLPAY:
    case PAYMENT_TYPES.AP_AMEX:
    case PAYMENT_TYPES.AP_DISCOVER:
    case PAYMENT_TYPES.AP_MASTERCARD:
    case PAYMENT_TYPES.AP_VISA:
      return <ApplePayIcon size={size} {...rest} />;
    case PAYMENT_TYPES.DISCOVER:
      return <DiscoverIcon size={size} {...rest} />;
    case PAYMENT_TYPES.IDEAL:
      return <IdealIcon size={size} {...rest} />;
    case PAYMENT_TYPES.MC:
    case PAYMENT_TYPES.MASTERCARD:
      return <MastercardIcon size={size} {...rest} />;
    case PAYMENT_TYPES.PAYPAL_LITLE:
    case PAYMENT_TYPES.PAYPAL:
    case PAYMENT_TYPES.PAYPAL_BRAINTREE:
      return <PaypalIcon size={size} {...rest} />;
    case PAYMENT_TYPES.SEPA:
      return <SepaIcon size={size} {...rest} />;
    case PAYMENT_TYPES.VISA:
    case PAYMENT_TYPES.VI:
      return <VisaIcon size={size} {...rest} />;
    default:
      return null;
  }
};

export {
  AmexIcon,
  ApplePayIcon,
  AfterpayIcon,
  DiscoverIcon,
  IdealIcon,
  MastercardIcon,
  PaypalIcon,
  SepaIcon,
  VisaIcon,
  PaymentTypeIcon,
};
